import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSidebarTab } from '../../contexts/SidebarTabContext';

// RevisionPreguntas recibe sus datos y acciones de AdminPanel; montado suelto en
// /admin/revision no tenía props y rompía la página. La ruta se mantiene para
// enlaces guardados: abre el panel directamente en la pestaña de revisión.
const RevisionPreguntasPage = () => {
	const { setActiveTab } = useSidebarTab();

	useEffect(() => {
		setActiveTab('revision-preguntas');
	}, [setActiveTab]);

	return <Navigate to="/admin" replace />;
};

export default RevisionPreguntasPage;
